__turbopack_context__.v({
  "className": "playfair_display_4de7d062-module__NGhj4W__className",
  "variable": "playfair_display_4de7d062-module__NGhj4W__variable",
});
